export const HOME = {
  startFull: "home-start-full",
  startPhotos: "home-start-photos",
  adminLink: "home-admin-link",
  emergentLink: "home-emergent-link",
};

export const WIZARD = {
  stepLabel: "wizard-step-label",
  progressBar: "wizard-progress-bar",
  savedIndicator: "wizard-saved-indicator",
  back: "wizard-back-btn",
  next: "wizard-next-btn",
  skip: "wizard-skip-btn",
  saveLater: "wizard-save-later-btn",
  submit: "wizard-submit-btn",
  draftLink: "wizard-draft-link",
};

export const ADMIN = {
  loginEmail: "admin-login-email",
  loginPassword: "admin-login-password",
  loginSubmit: "admin-login-submit",
  table: "admin-projects-table",
  filterStatus: "admin-filter-status",
  search: "admin-search",
  exportCsv: "admin-export-csv",
  rowView: (id) => `admin-row-view-${id}`,
  generateCaseStudy: "admin-generate-case-study",
  downloadPdf: "admin-download-pdf",
  resendPdf: "admin-resend-pdf",
  changeStatus: "admin-change-status",
  archive: "admin-archive",
  settingsLink: "admin-settings-link",
  logout: "admin-logout",
};
